export const digitsCommaRegex = /\B(?=(\d{3})+(?!\d))/g
export const emailRegex =
  /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/
export const passwordRegex = '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=\\S+$).{8,}$'
export const workEmailRegex =
  /^\w+[-.\w]*@(?!(?:hotmail|outlook|me|yahoo|gmail|inbox|ymail|icloud|mail|live|yandex|temp-mail|aol|zoho|protonmail|gmx|tutanota)\.\w)\w+[-.\w]*?\.\w{2,4}$/
